import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/DynamicSetting`;


const ApiDynamicSetting = {
  getAboutUs: (params) => {
    const url = `${baseServiceUrl}/getAboutUs`;
    return ServiceApi.get(url);
  },
  getContactUs: (params) => {
    const url = `${baseServiceUrl}/getContactUs`;
    return ServiceApi.get(url);
  },
  createUpdateAboutUs: (params) => {
    const url = `${baseServiceUrl}/createUpdateAboutUs`;
    return ServiceApi.post(url, params);
  },

};






export default ApiDynamicSetting;


